export const ITEM_TYPE_PRODUCT = 3;

export const INIT_CURSOR_NUMB = -1;